export const PHONE_PATTERN =
  '^[1-9]\\d{8}$';
